export default "__VITE_ASSET__CQ9SvZOc__"